import { render, staticRenderFns } from "./OrderItemMenuPromo.vue?vue&type=template&id=30faf459&scoped=true&"
import script from "./OrderItemMenuPromo.vue?vue&type=script&lang=js&"
export * from "./OrderItemMenuPromo.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemMenuPromo.vue?vue&type=style&index=0&id=30faf459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30faf459",
  null
  
)

export default component.exports